import { apiBaseUrl, isLocalEnv } from '@config/environment'
import { tokenService } from '@features/auth'
import { ApiClient, ApiProvider, queryClient } from 'shared-ui/api-provider'
import { useLocalization } from 'shared-ui/localization'

export const ApiWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { locale } = useLocalization()

  const apiClient = new ApiClient({
    apiBaseUrl,
    tokenService: tokenService,
    credentials: 'include',
    locale
  })

  return (
    <ApiProvider queryClient={queryClient} apiClient={apiClient} showDevTools={isLocalEnv()}>
      {children}
    </ApiProvider>
  )
}
